// GENERATO DA scripts/genera_manuali_pubblici.mjs — non modificare a mano.
// Sorgente: data/manuali_pubblici.json (aggiornato il 2026-09-02).
//
// Notifier e Ajax pubblicano la propria documentazione senza registrazione.
// Per i documenti elencati qui l'app manda l'installatore alla pagina del
// costruttore invece di servire la nostra copia: nessuna riproduzione, nessuna
// barriera aggirata, e al costruttore arriva traffico. Restano nostri INIM e
// DAITEM, per cui serve il permesso scritto.
//
// src/lib/manualiPubblici.ts

export type ManualePubblico = {
  /** Indirizzo pubblico sul sito del costruttore. */
  url: string;
  /** Chi lo pubblica, per scriverlo accanto al collegamento. */
  costruttore: string;
  /** "pdf" accetta #page=N; "pagina" e' un articolo web e non ha pagine. */
  forma: "pdf" | "pagina";
};

export const MANUALI_PUBBLICI: Record<string, ManualePubblico> = {
  "AJAX__12-24V-PSU-type-A__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/12-24vpsu-hub2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__12-24V-PSU-type-A__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/12-24vpsu-hub2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__12V-PSU-for-Hub-Hub-Plus-ReX__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/12vpsu/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__12V-PSU-for-Hub-Hub-Plus-ReX__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/12vpsu/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__12V-PSU-for-NVR__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/12v-psu-for-nvr/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__6V-PSU-type-A__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/6vpsu-hub2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__6V-PSU-type-A__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/6vpsu-hub2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-BulletCam-5-Mp-28-mm-8EU-ASP-black__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-DomeCam-Mini-5-Mp-28-mm-8EU-ASP-black__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Heat-Sounder__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-heat-sounder-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Heat__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-heat-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Smoke-Sounder__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-smoke-sounder-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Smoke__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-smoke-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Sounder-VAD__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-sounder-vad-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-Sounder__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-sounder-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-EN54-FireProtect-VAD__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-vad-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-FireProtect-2-AC-CO-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-FireProtect-2-AC-Heat-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-FireProtect-2-AC-Heat-CO-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-FireProtect-2-AC-Heat-Smoke-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-FireProtect-2-AC-Heat-Smoke-CO-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-MotionCam-HDR-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-OutletCore-LAN__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/outlet-lan/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Servizi-Ajax__Guida-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/services/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-SIM__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-sim/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-SpaceControl-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajaxspacecontrol/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-SpaceControl-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajaxspacecontrol/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-BulletCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-bulletcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-BulletCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-bulletcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-DomeCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-DomeCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-MotionProtect-Plus-G3-Fibra-ASP-black__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-SpaceControl-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-superior-spacecontrol-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-SpaceControl-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-superior-spacecontrol-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-TurretCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-Superior-TurretCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-TurretCam-5-Mp-28-mm-8EU-ASP-black__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-WaterStop-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/waterstop/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Ajax-WaterStop-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/waterstop/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HL-5-Mp-28-mm__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HLVF-5-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-bulletcam-hlvf-nm/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-bulletcam-hlvf-nm/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajax-bulletcam-hlvf-nm/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HL__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam-HL__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__BulletCam__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/bulletcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Button-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/button/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Button-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/button/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Button-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/button/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CableTrunk-black__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/cabletrunk/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Case-E-395__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/case-e-395/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Case-E-395__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/case-e-395/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CombiProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/combiprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CombiProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/combiprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CombiProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/combiprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Curtain-Outdoor-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtain-outdoor-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Curtain-Outdoor-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtain-outdoor-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Curtain-Outdoor-Mini-Jeweller__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtain-outdoor-mini-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Curtain-Outdoor-Mini-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtain-outdoor-mini-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Curtain-Outdoor-Mini-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtain-outdoor-mini-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CurtainCam-Outdoor-HighMount-PhOD-Jeweller__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtaincam-outdoor-highmount-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CurtainCam-Outdoor-HighMount-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtaincam-outdoor-highmount-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__CurtainCam-Outdoor-HighMount-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/curtaincam-outdoor-highmount-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Dispositivi-di-segnalazione-acustica-e-VAD-EN54-FireProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-vad-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Dispositivi-di-segnalazione-acustica-e-VAD-EN54-FireProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-vad-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-HLVF-5-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-Mini-HL-5-Mp-28-mm__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-Mini-HL__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-Mini-HL__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-Mini__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DomeCam-Mini__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/domecam-mini/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorBell__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorbell/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorBell__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorbell/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-Plus-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoorProtect__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doorprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoubleButton-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doublebutton/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoubleButton-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doublebutton/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DoubleButton-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/doublebutton/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DualCurtain-Outdoor-ASP__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/dualcurtain-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DualCurtain-Outdoor-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/dualcurtain-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__DualCurtain-Outdoor-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/dualcurtain-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-Fire-Hub-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fire-hub-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-Fire-Hub-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fire-hub-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-Fire-ReX-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fire-rex-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-Fire-ReX-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fire-rex-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-I-O-Module-2X2-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-io-module-2x2-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__EN54-I-O-Module-2X2-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-io-module-2x2-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Smoke-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Smoke-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Smoke-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-AC-Heat-Smoke-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-ac-heat-smoke/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Smoke-CO-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-smoke-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Smoke-CO-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-smoke-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Smoke-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-smoke/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-Heat-Smoke-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-smoke/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-RB-CO-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-RB-Heat-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-2-RB-Heat-CO-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-2-heat-co/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__FireProtect-Plus-with-CO-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/fireprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__GlandBox__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/glandbox/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__GlassProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/glassprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__GlassProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/glassprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__GlassProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/glassprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__HomeSiren-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/homesiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__HomeSiren-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/homesiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__HomeSiren-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/homesiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-Plus-8-ECG-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-2G-4G-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-BP-Jeweller-8EU-UEU__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-bp/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-BP-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-bp/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-BP-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-bp/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Hub-Plus-ASP-Phase-out__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/hub-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__IndoorCam__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/indoorcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__IndoorCam__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/indoorcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Internal-battery-NB-72V-190Ah__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/internal-battery-nb-190ah/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Internal-battery-NB-72V-95Ah__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/internal-battery-nb-95ah/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Internal-battery-RB-64V-78Ah__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/internal-battery-rb-78ah/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Outdoor-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-outdoor-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Outdoor-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-outdoor-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-TouchScreen-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-touchscreen/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-TouchScreen-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-touchscreen/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__KeyPad-TouchScreen-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-touchscreen/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Keypad-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Keypad-Plus-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/keypad-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LeaksProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/leaksprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LeaksProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/leaksprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LeaksProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/leaksprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LifeQuality-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/lifequality/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LifeQuality-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/lifequality/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LifeQuality-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/lifequality/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LifeQuality-Lite-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/lifequality-lite-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__LifeQuality-Lite-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/lifequality-lite-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Manual-Call-Point-Red-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/manualcallpoint-red-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ManualCallPoint-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/manualcallpoint-black-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ManualCallPoint-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/manualcallpoint-black-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ManualCallPoint-Red-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/manualcallpoint-red-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ManualCallPoint-Red-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/manualcallpoint-red-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-HighMount-PhOD-Jeweller-8EU-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor-highmount-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-HighMount-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor-highmount-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-HighMount-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor-highmount-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-Outdoor-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-outdoor-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionCam-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motioncam-phod/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Curtain-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-curtain/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Curtain-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-curtain/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Curtain-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-curtain/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Outdoor-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Outdoor-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Outdoor-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-outdoor/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Plus-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MotionProtect-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/motionprotect-plus/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MultiTransmitter-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/multitransmitter/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__MultiTransmitter-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/multitransmitter/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__NVR-8ch-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__NVR-HAC-8ch__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__NVR__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__NVR__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ReX-2-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/rex-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ReX-2-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/rex-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ReX-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/rex/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__ReX-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/rex/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Relay-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/relay/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Relay-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/relay/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Relay-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/relay/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Rilevatori-EN54-FireProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-heat-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Rilevatori-EN54-FireProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/en54-fireprotect-heat-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-Ajax-Superior-NVR-H2D__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-nvr-h2daip/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-Ajax-Superior-NVR-H2D__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-nvr-h2daip/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-NVR-H2D__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr-h/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-NVR-H2D__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr-h/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-NVR-H__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr-h/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Serie-NVR-H__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/nvr-h/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Socket-type-F-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/socket-type-f/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Socket-type-F-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/socket-type-f/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__SpaceControl-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/ajaxspacecontrol/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__SpeakerPhone-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/speakerphone-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__SpeakerPhone-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/speakerphone-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-DoubleDeck-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren-doubledeck/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-DoubleDeck-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren-doubledeck/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-DoubleDeck-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren-doubledeck/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__StreetSiren-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/streetsiren/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-BulletCam-HLVF-4-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-bulletcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Button-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-button-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Button-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-button-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-CombiProtect-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-combiprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-CombiProtect-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-combiprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-CombiProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-combiprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-CombiProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-combiprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DomeCam-HLVF-4-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-domecam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-G3-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-G3-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Plus-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Plus-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoorProtect-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doorprotect-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoubleButton-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doublebutton-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-DoubleButton-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-doublebutton-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-GlassProtect-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-glassprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-GlassProtect-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-glassprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-GlassProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-glassprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-GlassProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-glassprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-HomeSiren-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-homesiren-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-G3-Jeweller__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-Hybrid-2G__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-hybrid-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-Hybrid-2__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-hybrid-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-Hybrid-2__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-hybrid-2/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-Hybrid__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-hybrid/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Hub-Hybrid__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-hub-hybrid/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Outdoor-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-outdoor-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Outdoor-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-outdoor-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Plus-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Plus-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-TouchScreen-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-touchscreen-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-TouchScreen-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-touchscreen-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-TouchScreen-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-touchscreen-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-KeyPad-TouchScreen-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-keypad-touchscreen-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineProtect-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-lineprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineProtect-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-lineprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineSplit-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-linesplit-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineSplit-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-linesplit-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineSupply-45-W-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-linesupply-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineSupply-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-linesupply-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-LineSupply-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-linesupply-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-AM-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-am-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-AM-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-am-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-G3-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-g3-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-G3-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-g3-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-HD-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-hd-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-HD-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-hd-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-PhOD-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-phod-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-PhOD-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-phod-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-PhOD-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionCam-PhOD-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motioncam-phod-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-G3-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-G3-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-G3-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-G3-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MotionProtect-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-motionprotect-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiRelay-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multirelay-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiRelay-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multirelay-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-G3-Jeweller-without-casing__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-g3-jeweller-without-casing/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-IO-4X4-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-io-4x4-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-MultiTransmitter-IO-4X4-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-multitransmitter-io-4x4-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-ReX-G3-Jeweller__Manuale-Utente__EN.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-rex-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-ReX-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-rex-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-ReX-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-rex-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-SeismoProtect-G3-Fibra-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-seismoprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-SeismoProtect-G3-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-seismoprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-SeismoProtect-G3-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-seismoprotect-g3-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-DoubleDeck-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-doubledeck-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-DoubleDeck-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-doubledeck-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-DoubleDeck-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-doubledeck-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-DoubleDeck-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-doubledeck-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-G3-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-G3-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-g3-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-StreetSiren-Plus-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-streetsiren-plus-jeweller/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Transmitter-Fibra__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-transmitter-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-Transmitter-Fibra__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-transmitter-fibra/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Superior-TurretCam-HLVF-4-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/superior-turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Transmitter-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/transmitter/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Transmitter-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/transmitter/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__Transmitter-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/transmitter/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HL-5-Mp-28-mm__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HLVF-5-Mp__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HLVF__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HLVF__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hlvf/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HL__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam-HL__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam-hl/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__TurretCam__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/turretcam/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__WallSwitch-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/wallswitch/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__WallSwitch-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/wallswitch/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__WallSwitch-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/wallswitch/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__WaterStop-1-2-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/waterstop/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__uartBridge-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/uartbridge/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__vhfBridge-ASP__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/vhfbridge/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__vhfBridge-Jeweller__Manuale-Utente__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/vhfbridge/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "AJAX__vhfBridge-Jeweller__Scheda-Tecnica__IT.pdf": {
    "url": "https://ajax.systems/it/support/manuals/vhfbridge/",
    "costruttore": "Ajax Systems",
    "forma": "pagina"
  },
  "NOTIFIER__251-003__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101441_THE-8000%20THE-40032-%20smoke%20test-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__40-40DLB631SCY7__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051239_40-40%20rivelatore%20lineare-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__585000__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202208031459_VARIODYN%20ONE%20brochure%20A4%208pp_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__80638F__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204061330_80638F%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__80638F__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1730_80638F-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__960120__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1224_HON-DS-003-01_IT.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AEI-485__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801100851_AEI485-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AEI3__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801100844_AEI3-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AL-PM544-X2__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203180920_UPS%20EGR%20EGRS-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ALC__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801160845_ALC%20AL-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ALI50EN__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204201055_ALI50EN-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ALI50EN__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1112_ALI50EN_DEP_ITA_H.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ALI8-8__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801160851_ALI8-8-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8100__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202403261518_AM%208100-manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8100__Manuale-Programmazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202203080825_AM-8100%20manu-prog-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8100__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202504011037_AM-8100%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8100__Scheda-Tecnica__IT__Centrali-Notifier-Serie-AM-Aaa.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202504011037_AM-8100%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200G__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202503031411_AM%208200G-manu-inst-italiano.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200G__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202503031413_AM-8200G%20manuale%20di%20prog-italiano.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200G__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202505070916_AM-8200G%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200N__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202403261516_AM%208200N-manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200N__Manuale-Programmazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202210100754_AM-8200N%20manu-prog-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202504011038_AM-8200N-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-LCDG__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202601081055_AM-LCDG%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-LCD__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202510270803_AM-LCD%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-LCD__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202404240857_AM-LCD-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM1000CL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202404171454_AM1000CL-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM1246K-PLUS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202601230813_AM1246K-ITA%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM2000CL__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202404171448_AM-CL%20manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM2000CL__Manuale-Programmazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202404171450_AM-CL%20manu-prog-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM2000CL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202306200859_AM2000CL-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM6000CL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202308290933_AM6000CL-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM82-CL__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202404300852_AM82-CL%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM82-CL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202404300852_AM82-CL%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AT-2SR__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202307120944_AT-2SR-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AT-2S__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202307120943_AT-2S-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AT-E-WX__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203031726_AT-E%20WX%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AT-E-X__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1217_Segnalatori%20Atex-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ATI-1000R__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203180943_ATI-1000R-HONpdf.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__B100__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204190951_B100%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__B100__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201712211037_B100%20dep-ita%20eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__B501AP__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202211006_B501AP-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__B501AP__Schemi-Collegamento__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/disegni/201906070648_ISA_evento6giugno.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BG14ADPE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202109061056_Pulsanti%20Convenzionali%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BGL-PC-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105050832_BGL-PC-I02-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BGL-PC-I02__Scheda-Tecnica__IT__BGL-PC-I02-sk-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105050833_BGL-PC-I02-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BRH-PC-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105050828_BRH-BRS-PC-I02-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BRH-PC-I02__Scheda-Tecnica__IT__BRH-PC-I02-sk-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105050829_BRH-PC-I02-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__BRS-PC-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105050831_BRS-PC-I02-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CBUS2075-FR__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203040801_CBUS2075-FR_120Ohm%20-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CC-2M__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202108030926_CC-2M%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CC-4M__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202108030927_CC-4M%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CCM2-GLOBAL__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202508291408_CCM2-GLOBAL%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CCM2-GLOBAL__Manuale__IT__Dual-SIM-CCM2-GLOBAL-Quick-Sta.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202508291408_Dual%20SIM%20CCM2-GLOBAL-Quick-Start-Guide_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CGI-PSU__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202307120945_CGI-PSU-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CGV-PSU__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202307120946_CGV-PSU-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CMA11E-NI__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202507180958_CMA11E-NI%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CMA22__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205061401_CMA22-sk-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CMA22__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1143_CMA22-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CME21__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202410091048_CME21%20sk-ita%20.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CME21__Manuale__IT__CME21-manu-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202605041456_CME21%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CME21__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202503070741_CME21%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CMX-10RME__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1745_cmx-10RME-dep-itA-ENG.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__COM-ENET__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202002070900_COM-ENET_sk_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CSRLS-2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101552_ILIA-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CSRLS-2__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/ILIA-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CV-T68__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902131314_CAVOTERM-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CWSO-RR-S1__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202202211014_CWSO%20e%20CWSS%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CWSO-RR-S1__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/CWSO_Sirene_DEP_ITA-ENG.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CWSS-RB-S7__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/CWSS-RB-NO_EN54-23_DEP_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CWSS-RW-S5__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/CWSS_Sirene_lampeggiante_DEP%20ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__CWST-RW-S5__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/CWST_Lampeggiante_DEP%20ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__D2E__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202204051224_D2E%20SK%20ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__D2E__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902110908_D2E-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DGF30T__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202402071514_13_01%20Manual%20DGF15T_DGF30T.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DNRE-HS__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202507030644_DNRE-HS-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DNRE__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205021342_DNRE-manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DS500__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202605041459_DS500%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DS500__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202406241159_DS500%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DS500__Scheda-Tecnica__IT__DS500-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202503070742_DS500%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE1-EN__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202202211022_DSE-1EN-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE1-EN__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202211020_DSE1%20SERIE%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE1-EN__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1558_DSE-EN_dep_ITA-ENG.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE1-PW__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204060844_DSE1-PW%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE1-PW__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202404151156_DSE1%20SERIE%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__DSE3-23-HW__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902120802_DSE3-23-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__E-NET4P-N__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202507231019_E-NET4P-N%20manu%20inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__E-NET4P-N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202501241150_E-NET4P-N%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__E-SIB__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203080823_AM-8100-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__EFC-PS524__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051509_EFC-PS524%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__EFC-PS524__Manuale__IT__EFC-PS524-QuickGuide-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051510_EFC-PS524%20QuickGuide-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__EFC-PS524__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902111508_EFC-PS524-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ELE4-N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411141022_ELE4-N-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ER-L7__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801170850_ER-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ETH1-C__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801160944_ETH-C-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ETH1__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801100941_ETH-1-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FD-851RE-A__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/145_I56-1730-014%20FD-851RE_FD-851TE_FD-851HTE.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FG1625TAS__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1216_HSCE_FG1625TAS_01_IT_0906_IA_C.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FRONT-PAN1-PL-X__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910310834_POL-200-TS%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FS20X-211-23-6__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203101553_FS20-24X%20Brochure-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FS24XP-AMGXX__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202505200950_Brochure%20FS24X%20PLUS-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FS24XP-AMGXX__Scheda-Tecnica__IT__FS24X-PLUS-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202505200951_FS24X%20PLUS%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FSL100-UV__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902110922_FSL100%20Brochure-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__FTT5__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202301261141_FTT5-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__G700C-42__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202006231228_G700C-42%20E700C-42-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__G700C-AS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205041508_G700C-AS%20H703-AS-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__G702C-SS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205061407_G700-%20H700%20-SS-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__G702C-SS__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/149_Serie700-SS_DEP_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HLSPS15__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411081324_HLSPS15%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HLSPS25__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205041453_HLSPS25%20-%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HLSPS25__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1150_HLSPS-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HOA-335-043__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202606190756_Ripetitore%20Inspire%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HOA-335-043__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202603180830_Pannello%20ripetitore%20Inspire%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HON-CGW-MBB__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202309151238_CLSS_Cyber%20Security-%20ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HON-CGW-MBB__Manuale__IT__CLSS-Gateway-Quick-Installatio.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202309151239_CLSS_Gateway_Quick_Installation_Guide__ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HON-CGW-MBB__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202309151236_Brochure%20CLSS-ita-end%20users.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HON-CGW-MBB__Scheda-Tecnica__IT__HLS-CLSS-Facility-Owner-Flyer-.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202309151237_HLS_CLSS%20Facility%20Owner_Flyer_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HON-CGW-MBB__Scheda-Tecnica__IT__HLS-CLSS-Partner-Flyer-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202309151238_HLS_CLSS%20Partner_Flyer_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HOP-131-206__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061536_NF-BR-INSPIRE-Brochure-EMEA-IT_May%2024.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HOP-131-206__Scheda-Tecnica__IT__NOTIFIER-INSPIRE-datasheet-ITA.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061538_NOTIFIER_INSPIRE-datasheet_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HT-DZII__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202205061417_ht-dzii.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HW-LTE-M-EN54__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061545_CLSSPathwayDealerFlyer_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HW-LTE-M-EN54__Scheda-Tecnica__IT__CLSSPathwayEnd-UsersFlyer-ITA.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061546_CLSSPathwayEnd-UsersFlyer_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__HW-LTE-M-EN54__Scheda-Tecnica__IT__Hon-Pathway-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061549_Hon%20Pathway%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__IDX-751-AE__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711131418_IDX-751-dep-ita%20eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__IIG4N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/IIG4N_dep_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__IND8-4__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903280755_IND8-4-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__IND8-4__Scheda-Tecnica__IT__IND8-4-sk-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202307120746_IND8-4-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__IND8-N-ETH__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202605071433_IND8-N-ETH-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INDIC-INC__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203031751_INDICATOR%20ripetitori-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INDICATOR__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711131419_INDICATOR%20ripetitori-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-485-T2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411081334_INS-WX-485-T2-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-485__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/1122_INS-WX-485-8290_SK_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-485__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903211122_INS-WX-485-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-DE__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/1126_INS-WX-DE-S8151.1%20ITA%20r2.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-DE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903211113_INS-WX-DE-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-D__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/1125_INS-WX-D_8150_SK_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WX-D__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903211117_INS-WX-D-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-WXFP-D__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/201905221032_INS-WXFP-D-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-X-485-O__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004280932_INS-X-485-O-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-X-DO__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004280928_INS-X-DO-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-X-D__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004280926_INS-X-D-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INS-X-ETH485__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004280930_INS-X-ETH485-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INSPIRE-SELF-TEST-e-CLSS__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410240833_Brochure%20INSPIRE-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INSPIRE-SELF-TEST-e-CLSS__Scheda-Tecnica__IT__Brochure-CLSS-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410240834_Brochure%20CLSS%20-%20ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INSPIRE-SELF-TEST-e-CLSS__Scheda-Tecnica__IT__Brochure-TRIFECTA-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410240835_Brochure%20TRIFECTA-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INSPIRE-SELF-TEST-e-CLSS__Scheda-Tecnica__IT__INSPIRE-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410240837_INSPIRE%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INSPIRE-SELF-TEST-e-CLSS__Scheda-Tecnica__IT__SELF-TEST-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410240838_SELF-TEST%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-WX-485-T2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202410170911_INT-WX-485-T2-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-WX-DE__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/1131_INT-WX-DE-S8153.1%20ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-WX-DE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903211120_INT-WX-DE-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-WX-D__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/1128_INT-WX-D_8152_SK_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-WX-D__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903211119_INT-WX-D-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INT-X-D__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903221112_INT-X-D-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__INX-N-ETH__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202607020849_INX-N-ETH-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__ISP-1000__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203221556_ISP-1000%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__KIT-EXCHANGE-N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202501171013_KIT-EXCHANGE-N-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__L485__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161226_L485-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LCD-8200__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202202221345_LCD-8200-manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LCD600S__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161230_LCD600S-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LIB-8200N__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202210100752_AM-8200N%20manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-8200__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202202221309_AM-8200%20manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LIB-AMCL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202306200903_AM6000CL-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LT-SEN-M3__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202309150729_Li-ion_Tamer_GEN3_dep_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__LT-SEN-M3__Scheda-Tecnica__IT__Brochure-VESDA-Li-Ion-Tamer-IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202309150731_Brochure%20VESDA_Li-Ion%20Tamer_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M-485IG__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202505301505_M-485IG-SK_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M-CONT-ID__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161243_M-CONT-ID-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M-ECH4-BASE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161245_M-ECH2%20M-ECH4%20base-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M-FO-MONO__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411141016_M-FO-MONO-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M-FO-MULTI__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411141015_M-FO-MULTI-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M200E-SMB__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202412041130_M710E%20M720E%20M721E%20-%20sk-multilingua.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M3A-R000SG-STCK-01__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1026_Pulsanti%20Convenzionali.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M5A-RP02SG-N026-01__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910290856_M5A-W5A%20Pulsanti%20Indirizzati-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M700X__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201710231738_M700X-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M701E-240__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202204070928_M701E-240%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M701E__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104160855_M701E-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M710E-CZR__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202211091049_I56-4421-000%20M710E-CZR.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M710E-CZ__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051313_SISTEMA_ANALOGICO-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M710E-CZ__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202211091026_I56-4420-000%20M710E-CZ.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M710E__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204061032_M710E%20M720E%20M721E%20-%20sk-multilingua.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M710E__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104160902_M710E-M720E-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__M721E__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104160919_M721E-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MAB__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801100842_MAB-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MB-CGI__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202001241326_CGI-PSU-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MBC__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104261336_MBC-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MCX-55ME__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204080705_MCX-55M-sk-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MCX-55ME__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1711_MCX-55ME_dep_ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MGP-X__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161252_MGP-X-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MGP2-E__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201907291344_MGP2-E-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MGP3__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104200923_MGP3-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MGV-485__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161255_MGV-485-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MI-CARD__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/201902071114_MI-CARD-4K-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MINIDOGE-L__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161609_MINIDOGE-L-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MLON__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202301261143_MLON-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MMT-N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202507181004_MMT-N%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MMX-10ME__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204080719_MCX-55M-sk-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MMX-10ME__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1742_MMX-10ME_depl_ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MONITOR-SERVER__Manuale-Programmazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202101211421_MONITOR_2-7-manu-prog-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MONITOR-SERVER__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202101211423_X-MONITOR%20MANU%20PROG%20ITA%20RA1.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MORS-0__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801100831_MORS-0-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MORS-4__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161429_MORS-4-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MORS-85__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202605200620_MORS-85%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MURANO-LSP__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/MuranoLSP.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__MX6Z-AN__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1050_Sistema%20Audionet%20MX-SK-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFG-8__Manuale-Installazione__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202607080643_NFG-8%20manu-inst-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFG-8__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/201902081040_NFG-8-Quick_Guide-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFG-8__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202607080636_NFG-8-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFS12-SUPRA__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412031027_NFS4-8-12%20SUPRA%20centrali%20convenzionali-dep-Ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFS4-SUPRA__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204191510_NFS4_NFS8-2PLUS_MANU_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFS4-SUPRA__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201712190935_NFS4-8-2PLUS%20centrali%20convenzionali-dep-Ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFSTI-OPT__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412061611_NOTIFIER_Self-Test%20NFSTI_DS_ITA_June24.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFX-OPT-IV__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910301501_NFX_OPT_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFX-SMT2-IV__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910301503_NFX_SMT2_ITA_A2.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFX-SMT3-IV__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910301457_NFX_SMT3_ITA_A1.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-BEAM-40-E__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202410090623_NFXI-BEAM-40%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-BEAM-40-E__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/NFXI%20-beam%20e%206500R_dep_ITA-ENG%20a3.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-FLX-010__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202603111325_FAAST%20FLEX%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-FLX-010__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202603111325_FAAST%20FLEX%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-OPT__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/133_I56-3388-004%20NFX-OPT.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-OPT__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201910240709_RMA%20Servizio%20di%20Revisione%20Rivelatori%20Puntiformi.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-OPT__Scheda-Tecnica__IT__NFXI-OPT-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202010141318_NFXI-OPT-%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-OSI-RIE__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202604281239_OSI-RIE_Installation_Guide.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-OSI-RIE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202604281229_NFXI-OSI-RIE-datasheet_notifier-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-SMT2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101606_NFXI-SMT2-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-SMT3__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101515_NFXI-SMT3-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NFXI-TDIFF__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101502_NFX-T-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NRX-USB__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201905231431_AGILE%20sistema%20wireless-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NRXI-GATE__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202203220954_AGILE%20-%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NRXI-GATE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903290825_Agile%20Wireless%20Brochure-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NRXI-GATE__Scheda-Tecnica__IT__AGILE-dep-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202007221325_AGILE-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NS-MULTI-2ETH__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202605071436_NS-MULTI-2ETH-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NS-MULTI-ETH__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202501171437_NS-MULTI-ETH-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NTF-CI03__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/NTF-CI03%20-%20D-8216.1%20ITA%20r.A2.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__NVR-SVH__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202204290925_NVR-SVH_ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__OSI-10__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1538_OSID-DEP-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__OSI-RE-SS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202404151159_OSI-RE-SS_Installation_Guide.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__OSI-RE-SS__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202404151158_OSI-RE-SS%20-%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__OUD32R-BASE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161435_OUD32R%20BASE-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__P700N__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202205161236_P700N-sk-ita_eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PAN1-PLUS-EN3__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204201555_PAN1-PLUS-EN3%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PAN1-PLUS-Y__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051254_PAN1-PLUS%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PAN1-PLUS-Y__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201911191327_PAN1-PLUS-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PANELVIEW__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204061344_Pview-%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PC-ENET__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202411081332_PC-ENET-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PLEX-VAD__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202109200816_PLEX%20-VAD%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__POL-200-TS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204060907_POL-200-TS-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PTL-611__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101632_PTL-611-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PY-X-M-05-CL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101612_PFANNENBERG%20segnalatori-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__PY-X-M-10__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202607061414_PFANNENBERG%20segnalatori-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__QUADRO-F12-3G-3D__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1217_Segnalatori%20Atex-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RA-T__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105191008_RA-T-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RASN-AN__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202205191231_SLT-AN%20-%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RIP3012__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203111048_RACK%20IP30.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RIV-601-F__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201711101645_RIV.601F-FA-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RIV-601-S__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204191002_05S.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RIV-601-S__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201710231740_RIV-601-S%20dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RP1R-2PLUS__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202606190800_RP1R-PLUS%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RT-BASE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202002250955_RT%20BASE-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__RXE__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161445_RXE-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__SC100__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/1622_HSC-SC10X-02-IT%281210%29DS-E.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__SCP-50-12__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161447_SCP-50-12-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__SD-851E-A__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202204190854_SD851%20FD851%20rivelatori%20convenzionali-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__SIB-8200__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202006221409_SchedeSIB-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__SMK400EAP__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202250729_SMK400EAP-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__STS3REL__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202171726_SKBR3N-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__STUM__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202203180939_STUM.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__Servizio-di-Revisione-e-Pulizia__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004200711_RMA%20Notifier.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TAD-ETH-T2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202601231455_TAD-ETH-T2-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TAD-FTT-T2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202601231454_TAD-FTT-T2-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TMP2-D-A2-R-1-A__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051351_TMP-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TMP2-D-A2-R-1-A__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202602091040_TMP2%20rivelatori%20di%20temperatura-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TR-2P__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161457_TRP-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TR-CARD-N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/TR-CARD%20S-8112.1%20ITA%20r.A2.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TR-CARD__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801161455_TR-CARD-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__TR-KEY__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202105201435_TR-KEY-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__UDS-4N__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202410251410_UDS-4N-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__UDS-4N__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104061354_UDS-4N%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__UTKEM50B__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202281628_UTKEM50SY-UTKEM50BY%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__UTKFM05__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202202230940_UTKFM05-10-sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VEP-A00-P__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412051004_VESDA-E_VEP_Italian.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VES-A00-P__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202412051012_VESDA-E_VES_Italian.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGN-PARK-VB__Manuale__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204080637_VGN-PARK-manu-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGN-PARK-VB__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/vgnpark-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-AD-NN__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202001150914_VGS%20TOX%20dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-CO2-2__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201909121029_VGS%20CO2-rivelatori%20gas-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-ME__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204050926_VGS%20Infiammabili_manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-ME__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201908021415_VGS%20EXP%20dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-O2__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202204051041_VGS%20TOSSICI-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-O2__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201903201438_VGS%20TOX%20dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VGS-DU-VB__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202001141637_VGS%20EXP%20dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VLF-250-01__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202007171452_VESDA_VLF-250_1_tubo%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VLF-500-01__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202007171453_VESDA_VLF-500_1_tubo%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VPS-220-STX5__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202007201505_Alimentatori_VESDA_VPS-2x0-STX%20sk-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VSN2-LT__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202203031419_VSN-2-4-8%20manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VSN2-LT__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201801081223_VSN-248%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__VULGAS__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/201902131456_VULGAS-dep-ita-eng.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__W3A-R000SG-K013-81__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202004061101_M3A-W3A%20Pulsanti%20Convenzionali%20IS-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WIN-FIRE-4__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202203220903_WIN-FIRE-manu-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WIN-FIRE-4__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202006181312_WIN-FIRE-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WRA-PC-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202406200741_Serie%20WRA%20e%20WWA%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WRL-RC-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202406200743_Serie%20WRL%20e%20WWL%20dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WSO-PR-I02__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/124_Sirene%20Indirizzate.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__WSO-PR-I02__Scheda-Tecnica__MULTI.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202104010759_WSO-WSS%20sk-multilingua.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__miniVES-2001-L__Manuale__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202011100910_MiniVes-Short%20manual-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__miniVES-2001-L__Manuale__IT__miniVES-Startup-veloce-V3.pdf": {
    "url": "https://www.notifier.it/static/upload/manuali/202403071117_miniVES%20-%20Startup%20veloce%20V3.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__miniVES-2001-L__Scheda-Tecnica__IT.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202011100903_Brochure-MiniVes-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__miniVES-2001-L__Scheda-Tecnica__IT__MiniVES-datasheet-ita.pdf": {
    "url": "https://www.notifier.it/static/upload/datasheets/202011100907_MiniVES-datasheet-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-Serie__Manuale-Installazione__IT.pdf": {
    "url": "https://prod-edam.honeywell.com/content/dam/honeywell-edam/hbt/en-us/documents/manuals-and-guides/installation-guides/notifier-it/HBT-Fire-202202221103-AM-Serie-manu-inst-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-Serie__Manuale-Programmazione__IT.pdf": {
    "url": "https://prod-edam.honeywell.com/content/dam/honeywell-edam/hbt/en-us/documents/manuals-and-guides/programming-manuals/notifier-it/HBT-Fire-202202221104-AM-Serie-manu-prg-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM-Serie__Manuale-Utente__IT.pdf": {
    "url": "https://prod-edam.honeywell.com/content/dam/honeywell-edam/hbt/en-us/documents/manuals-and-guides/user-manuals/notifier-it/HBT-Fire-202202221105-AMserie-manu-user-ITA.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  },
  "NOTIFIER__AM2000N__Scheda-Tecnica__IT.pdf": {
    "url": "https://prod-edam.honeywell.com/content/dam/honeywell-edam/hbt/en-us/documents/literature-and-specs/datasheets/notifier-it/HBT-Fire-201710171009-AM2000N-dep-ita.pdf",
    "costruttore": "Notifier by Honeywell",
    "forma": "pdf"
  }
};

/** L'indirizzo pubblico di un documento, alla pagina citata se il formato lo permette. */
export function manualePubblico(
  nomeFile: string | null | undefined,
  pagina?: number | null,
): (ManualePubblico & { href: string }) | null {
  if (!nomeFile) return null;
  const v = MANUALI_PUBBLICI[nomeFile];
  if (!v) return null;
  const href =
    v.forma === "pdf" && typeof pagina === "number" && Number.isFinite(pagina) && pagina > 0
      ? `${v.url}#page=${pagina}`
      : v.url;
  return { ...v, href };
}
